import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { Label, Button } from "reactstrap";
import { AlertPopups } from "../../../components/AlertPopups";
import Header from "../../../components/Header";
import { UserConsumer } from "../../../UserContext";
import "./monthlyTimesheetsConfig.css";
import { MonthlyTimesheetConfigAPIs } from "./MonthlyTimesheetsConfigAPIs";

const MonthlyConfigForm = () => {
	let token = null;
	const [formFields, setFormFields] = useState({
		dateForSupervisor: "",
		dateForAdmin: "",
	});
	useEffect(() => {
		getMonthlyTimesheetConfig();
	}, []);

	const handleChange = (e) => {
		setFormFields({ ...formFields, [e.target.name]: e.target.value });
	};
	const getMonthlyTimesheetConfig = () => {
		axios
			.get(`${MonthlyTimesheetConfigAPIs.GetMonthlyTimesheetConfig}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then(({ data }) => {
				setFormFields({
					dateForSupervisor: data.dateForSupervisor,
					dateForAdmin: data.dateForAdmin,
				});
			});
	};
	const updateMonthlyTimesheetConfig = () => {
		const body = {
			dateForSupervisor: formFields.dateForSupervisor,
			dateForAdmin: formFields.dateForAdmin,
		};
		axios
			.put(
				`${MonthlyTimesheetConfigAPIs.GetMonthlyTimesheetConfig}`,
				body,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				setFormFields({
					dateForSupervisor: data.dateForSupervisor,
					dateForAdmin: data.dateForAdmin,
				});
				AlertPopups.successAlert.fire({
					text: "Updated",
				});
				getMonthlyTimesheetConfig();
			})
			.catch((err) => {
				if (err.response) {
					if (formFields.dateForSupervisor === "") {
						AlertPopups.ErrorAlert.fire({
							text: "Please Enter Date for Supervisor",
						});
					} else if (formFields.dateForAdmin === "") {
						AlertPopups.ErrorAlert.fire({
							text: "Please Enter date for Admin",
						});
					} else
						AlertPopups.ErrorAlert.fire({
							text: `${err.response.data.message}`,
						});
				}
			});
	};
	const generateReportForcefully = () => {
		axios
			.get(
				`${MonthlyTimesheetConfigAPIs.GenerateMonthlyReportForcefully}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ data }) => {
				AlertPopups.successAlert.fire({
					text: "Report Generated Successfully",
				});
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.successAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<div className="container-fluid pr-3 pl-3">
						<Header
							title="Monthly Timesheet Config"
							headerBorder={true}
						/>
						<Label className="timesheetsConfigFormLabel mt-4">
							Configure The Monthly Timesheets
						</Label>
						<Form className="timesheetsConfigForm">
							<Row className="pt-2">
								<Col>
									<Form.Group className="d-flex align-items-center">
										<Form.Label className="supReviewDateLabel mb-0">
											Supervisor Review Date
										</Form.Label>
										<Form.Control
											name="dateForSupervisor"
											type="number"
											className="supReviewDate"
											value={formFields.dateForSupervisor}
											onChange={handleChange}
										/>
									</Form.Group>
								</Col>
								<Col>
									<Form.Group className="d-flex align-items-center">
										<Form.Label className="adminReviewDateLabel mb-0">
											Admin Review Date
										</Form.Label>
										<Form.Control
											name="dateForAdmin"
											type="number"
											className="supReviewDate"
											value={formFields.dateForAdmin}
											onChange={handleChange}
										/>
									</Form.Group>
								</Col>
							</Row>
							<div className="timesheetsConfigBtns">
								<Button
									onClick={updateMonthlyTimesheetConfig}
									className="submit-btn"
								>
									Save
								</Button>
								<Button
									onClick={generateReportForcefully}
									className="generateReport-btn"
								>
									Generate Monthly Report Forcefully
								</Button>
							</div>
						</Form>
					</div>
				) : (
					<Redirect to="/MyDashboard" /> //redirection for unauthorized users
				);
			}}
		</UserConsumer>
	);
};

export default MonthlyConfigForm;
